export { default as ProductDetailsHeader } from './ProductDetailsHeader';
